export default "__VITE_ASSET__hubRXcDo__"